import {
  useCatesModel,
  useProfileModel,
  useControllerModel,
  usePoisModel,
  useSelectionModel,
  useShopsModel,
  useSiteSelectionReportModel,
  useSituationModel,
  useStoreProfileModel,
  useTagsModel,
  useRegionInsightReportModel,
} from "@/models"
import { useCreation } from "ahooks-v2"
import { useCallback } from "react"
import { chartDarkStyle, chartLightStyle, defaultRange } from "@/constants/constant"
// ==============================================
function useCommon() {
  const { setStoreProfile } = useStoreProfileModel()
  const { setPoiValue } = usePoisModel()
  const {
    theme,
    // toggleAllShow
  } = useControllerModel()
  const { setAllState: setTagsAllState } = useTagsModel()
  const { setAllState: setCatesAllState } = useCatesModel()
  const { setAllState: setShopsAllState } = useShopsModel()
  const { setAllState: setProfileAllState } = useProfileModel()
  const { setAllState: setSelectionAllState } = useSelectionModel()
  const { setSiteSelection, setSiteSelectionReport } = useSiteSelectionReportModel()
  const { setReportId } = useRegionInsightReportModel()
  const { setAllState: setSituationAllState } = useSituationModel()

  // 清除所有缓存店铺、某类POI
  const clearShopCache = useCallback(() => {
    // 清除缓存店铺eco
    setStoreProfile(null)
    // 清除缓存某类POI
    setPoiValue({
      categoryName: undefined,
      categoryId: undefined,
      count: "0",
      isShow: false,
    })
    // 清空所有eco店铺
    setCatesAllState({
      cates: [],
    })
    // 场景拓客
    setShopsAllState({
      activeShop: undefined,
      activeSpecialization: undefined,
    })
    // 企业,商户,农村
    setProfileAllState({
      activeCompanyShop: undefined,
      companyShopService: undefined,
      activeBusinessShop: undefined,
      businessShopService: undefined,
      activeRuralShop: undefined,
    })
    // 智能选址
    setSelectionAllState({
      activeSitePoint: null,
    })
    // 选址报告
    setSiteSelection(null as any)
    setSiteSelectionReport(null as any)
  }, [
    setStoreProfile,
    setPoiValue,
    setShopsAllState,
    setProfileAllState,
    setSelectionAllState,
    setSiteSelection,
    setSiteSelectionReport,
    setCatesAllState,
  ])

  // 清除所有缓存数据
  const clearAllCache = useCallback(() => {
    // 清除缓存某类POI
    setPoiValue({
      categoryName: undefined,
      categoryId: undefined,
      count: "0",
      isShow: false,
    })
    // 场景拓客
    setShopsAllState({
      districtId: undefined,
      streetId: undefined,
      shops: [],
      activeShop: undefined,
      radius: defaultRange,
      radiusRange: [defaultRange],
      isCircleShow: false,
      selectedStores: [],
      isTaskShow: false,
      activeSpecialization: undefined,
      specializationList: [],
      bigDataCenterList: [],
    })
    // 企业,商户,农村
    setProfileAllState({
      activeCompanyShop: undefined,
      companyShopService: undefined,
      activeBusinessShop: undefined,
      businessShopService: undefined,
      activeRuralShop: undefined,
      ruralList: [],
    })
    // 智能选址
    setSelectionAllState({
      activeSitePoint: null,
      sitePointList: [],
    })
    // 选址报告
    setSiteSelection(null as any)
    setSiteSelectionReport(null as any)
    // 区域洞察报告
    setReportId(undefined)
    // 客情管理
    setSituationAllState({
      cardIds: [],
    })
    // 页面内容显隐
    // toggleAllShow(true)
    /**
     * 解决问题：经营情况选中的网点在其他页面被清空问题。
     * 不能清除网点原因：由于经营情况页地图变动城市地址及城市下拉不变造成此处网点不能清空。
     * */
    // 清除缓存网点
    // setBrandPoiValue(null)
    // 清除缓存店铺eco
    setStoreProfile(null)
    // 清空所有POI
    setCatesAllState({
      cates: [],
    })
    // tags
    setTagsAllState({
      selectedColors: new Map(),
      isIndustryShow: false,
      isOrganShow: false,
      crowdTags: [],
    })
  }, [
    setStoreProfile,
    setPoiValue,
    setShopsAllState,
    setProfileAllState,
    // setBrandPoiValue,
    setCatesAllState,
    setTagsAllState,
    // toggleAllShow,
    setSelectionAllState,
    setSiteSelection,
    setSiteSelectionReport,
    setSituationAllState,
    setReportId,
  ])

  // 获取组件的主题样式
  const chartStyle = useCreation(() => {
    if (theme === "light") {
      return chartLightStyle
    } else {
      return chartDarkStyle
    }
  }, [theme])

  return {
    chartStyle,
    clearShopCache,
    clearAllCache,
  }
}

export default useCommon
